const LIMITS = {
  tempA: [
    '( the minimum temperature is 121°C - 250°F )',
    '( the maximum temperature is 999°C - 1830°F )',
  ],
  tempB: [
    '( the minimum temperature is 25°C - 77°F )',
    '( the maximum temperature is 120°C - 248°F )',
  ],
};

/**
 * The control box's message when a widget refuses an input: a temperature
 * out of range (`tempA` for heat programs, `tempB` for constant temp), none
 * typed (`tempMissing`), or a TGS fan stop while a heating program runs
 * (`fanOnly`). `null` for anything else.
 */
export const inputMessage = (id, program) => {
  switch (id) {
    case 'tempA':
    case 'tempB':
      return [
        `in order to finalize ${program} `,
        'please input your temperature',
        ...LIMITS[id],
      ];
    case 'tempMissing':
      return ['temperature missing', 'please input temperature'];
    case 'fanOnly':
      return ['the fan should always run while the heater is running in tgs'];
    default:
      return null;
  }
};
